import { createRouter, createWebHistory } from 'vue-router'
import { localCache, sessionCache } from '@/utils/comm'
import { ACCESS_TOKEN, PROJECT_CURT_BIG_TYPE, PROJECT_CURT_SMALL_TYPE, USER_ID, USER_SYSTEM_ROLE } from '@/global/constants.ts'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'
import useUserStore from '@/store/user'
import { firstMenu } from '@/utils/system-permission'

const router = createRouter({
  history: createWebHistory(),

  routes: [
    {
      path: '/login',
      component: () => import('@/views/main/login/login.vue')
    },
    {
      path: '/invite-team',
      component: () => import('@/views/main/invite-team/invite-team.vue')
    },
    {
      path: '/invite-service',
      component: () => import('@/views/main/invite-service/invite-service.vue')
    },
    {
      path: '/invite-brand',
      component: () => import('@/views/main/invite-brand/invite-brand.vue')
    },

    {
      path: '/:pathMatch(.*)',
      component: () => import('@/views/main/not-found/not-found.vue')
    }
  ]
})

const whiteList = ['/login', '/invite-team', '/invite-service', '/invite-brand', '/']
router.beforeEach(async (to, from, next) => {
  if (to.path == '/project-detail' && from.path !== '/' && from.path !== '/project-put-report-edit') {
    sessionCache?.removeCache?.(PROJECT_CURT_BIG_TYPE)
    sessionCache?.removeCache?.(PROJECT_CURT_SMALL_TYPE)
  }

  // 只有登录成功(token), 才能真正进入到main页面
  NProgress.start()

  const token = localCache.getCache(ACCESS_TOKEN)
  const userId = localCache.getCache(USER_ID)
  const userSysRole = sessionCache.getCache(USER_SYSTEM_ROLE)

  if (token && userId) {
    if (to.path === '/login') {
      NProgress.done()
      next()
      // return true
    } else {
      // const user_sys_role = sessionCache.getCache(USER_SYSTEM_ROLE)

      if (useUserStore()?.userMenus?.length == 0) {
        await useUserStore().actionGetUserInfo()
        const routerList: any = await useUserStore().actionGetUserRouter(to.path)
        routerList.forEach((route: any) => {
          router.addRoute(route) // 动态添加可访问路由表
        })
        NProgress.done()

        if (from.path == '/login' || from.path === '/invite-team' || from.path === '/invite-service' || from.path === '/invite-brand') {
          // sessionCache.setCache(USER_SYSTEM_ROLE, user_sys_role || 'SERVICE')

          // return firstMenu.value.path
          next(firstMenu.value.path)
        } else {
          // return to.path == '/' || to.path == '/index' ? firstMenu.value.path : to
          const p = to.path == '/' || to.path == '/index' ? { path: firstMenu.value.path } : { ...to }

          next({ ...p, replace: true })
        }
      } else {
        NProgress.done()

        // await next()
        if (to.path == '/' || to.path == '/index') {
          next(firstMenu.value.path)
        } else {
          next()
        }
      }
    }
  } else {
    // 没有token
    // 在免登录白名单，直接进入
    if (whiteList.indexOf(to.path) !== -1) {
      NProgress.done()
      if (to.path == '' || to.path == '/') {
        next('/login')
      } else {
        next()
      }
      // return true
    } else {
      NProgress.done()
      // return '/login'
      next('/login')
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})

export default router
